<div class="home"><!--img(alt="Vue logo" src="@/assets/logo.png")--><HelloWorld msg="Welcome to Your Vue.js App"></HelloWorld></div>